const initState = {
  authError: null,
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN_ERROR":
      console.log("login error");
      return {
        ...state,
        authError: "login failed",
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        authError: null,
      };
    case "SIGNOUT_SUCCESS":
      console.log("signout success");
      return state;
    case "SIGNUP_SUCCESS":
      console.log("new user has been added");
      return {
        ...state,
        authError: null,
      };
    case "SIGNUP_ERROR":
      console.log("sign up error");
      return {
        ...state,
        authError: action.err.message,
      };
    case "MICROSOFT_LOGIN_SUCCESS":
      console.log("signing in with microsoft");
      return {
        ...state,
        authError: null,
      };
    default:
      return state;
  }
};

export default authReducer;
